/**
 * AlertEffect — "High Alert" status applied to enemies in alerted nodes.
 *
 * When the player fights a battle, adjacent battle/elite nodes go on alert.
 * Enemies in alerted nodes get bonus armor and attack.
 */

import type { StatusEffectDef } from "../../../framework/character";

export const HIGH_ALERT: StatusEffectDef = {
  id: "high_alert",
  name: "High Alert",
  modifiers: [
    { stat: "armor", value: 3 },
    { stat: "attack", value: 1 },
  ],
};
